export function getAppUrl(): string {
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}
